import React from "react";

export default function ScoreRing({
  score,
  size = 80,
  strokeWidth = 6,
  label,
  color: colorOverride,
}) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;

  const color = colorOverride || (
    score >= 90
      ? "#22c55e"
      : score >= 50
      ? "#f59e0b"
      : "#ef4444"
  );

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          {/* Background ring */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="#1e293b"
            strokeWidth={strokeWidth}
          />
          {/* Score ring */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            className="transition-all duration-700 ease-out"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="font-mono font-bold text-lg" style={{ color }}>
            {score}
          </span>
        </div>
      </div>
      {label && (
        <span className="text-xs text-gray-400 font-medium">{label}</span>
      )}
    </div>
  );
}
